import { EditableCardRow } from "../../../components/common";
import { ProfileSection } from "./ProfileSection";

export function CardPassword({ onClick }: { onClick: Function }) {
  return (
    <ProfileSection
      title="Senha"
      subtitle="Uma senha segura ajuda a proteger sua conta no Fluxmed"
    >
      <EditableCardRow
        title="Senha"
        titleContext="********"
        onClick={() => onClick()}
      />
    </ProfileSection>
  );
}
